module.exports = __webpack_public_path__ + "static/img/5.04e9c63.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/eng/5.png
// module id = RDwe
// module chunks = 0